import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import { UserSettingsModel } from '@models/user/userSettings.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserSettingsService {
  baseHref = `${environment.apiUrl}/users-settings`;

  constructor(private http: HttpClient) {}

  getSettings(): Observable<UserSettingsModel> {
    const url = `${this.baseHref}`;
    return this.http.get<any>(url);
  }

  getPreferredLanguage(): Observable<UserSettingsModel> {
    const url = `${this.baseHref}/language`;
    return this.http.get<any>(url);
  }

  getUserType(): Observable<UserSettingsModel> {
    const url = `${this.baseHref}/user-type`;
    return this.http.get<any>(url);
  }

  changeSettings(data: any): Observable<UserSettingsModel> {
    const url = `${this.baseHref}/`;
    return this.http.put<any>(url, data);
  }

  changeUserTypes(type: any): Observable<UserSettingsModel> {
    const url = `${this.baseHref}/change-user-types/${type}`;
    return this.http.get<any>(url);
  }

  getLocationRadius(): Observable<number> {
    const url = `${this.baseHref}/location-radius`;
    return this.http.get<any>(url).pipe(map((res) => res.locationRadius));
  }

  changeOfferMessageMode(
    mode: 'none' | 'ai' | 'templates',
  ): Observable<UserSettingsModel> {
    return this.changeSettings({ type: 'offerMessageMode', value: mode });
  }
}
